/*
  Плитки обязательного минимума - вариант Б макетов, выбранный владельцем
  30.09.2026: первым делом видно, по скольким счетам каждое сведение уже есть.

  Счёт считается в плитке, если сведение есть в портфеле или в присланных
  файлах: вкладка работает как дополнение к базе. Первая плитка - все счета,
  о которых файлы что-то сообщили, с ней сравнивают остальные.
*/

import { accounts, FACT_TITLES } from '../../api/format.js'

function Tile({ title, value, full }) {
  return (
    <div className={`tile${full ? ' tile--good' : ''}`}>
      <div className="money__label">{title}</div>
      <div className="money__value">{accounts(value)}</div>
    </div>
  )
}

export default function MinimumTiles({ summary }) {
  return (
    <section className="section">
      <h2 className="section__title">Обязательный минимум: по скольким счетам есть</h2>
      <div className="grid grid--even grid--five">
        {/* Первая плитка - общее число, с ним сравнивают остальные; зелёной она
            не бывает: «собрано у всех» про неё сказать нечего. */}
        <Tile title="Лицевой счёт" value={summary.accounts} full={false} />
        {summary.covered.map((item) => (
          <Tile
            key={item.fact}
            title={FACT_TITLES[item.fact] ?? item.fact}
            value={item.covered}
            full={summary.accounts > 0 && item.covered === summary.accounts}
          />
        ))}
      </div>
    </section>
  )
}
